// Select elements by selected tags
const SELECT_BY_TAGS = 'campaigns/common/SELECT_BY_TAGS'

export const types = { SELECT_BY_TAGS }

export const selectByTags = (tags, itemType, skipChangesMonitor = false) => ({ type: SELECT_BY_TAGS, tags, itemType, skipChangesMonitor })
